import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Chip } from '@mui/material';
import React from 'react';

type SegregateType = 'URGENT' | 'HIGH PRIORITY' | 'BACKLOG' | 'NOT IMPORTANT';

interface ISegregateChipProps {
    type: SegregateType;
}

const getChipProps = (type: SegregateType) => {
    switch (type) {
        case 'URGENT':
            return {
                label: 'Urgent',
                icon: <PriorityHighIcon sx={{ fontSize: 18 }} />,
                color: 'error' as const,
                tooltip: 'This issue requires immediate attention.',
            };
        case 'HIGH PRIORITY':
            return {
                label: 'High Priority',
                icon: <WarningAmberIcon sx={{ fontSize: 18 }} />,
                color: 'warning' as const,
                tooltip: 'This issue should be prioritized in upcoming sprint.',
            };
        case 'BACKLOG':
            return {
                label: 'Backlog',
                icon: <EventNoteIcon sx={{ fontSize: 18 }} />,
                color: 'info' as const,
                tooltip: 'This issue can be added to the backlog.',
            };
        case 'NOT IMPORTANT':
            return {
                label: 'Not Important',
                icon: <DoNotDisturbOnIcon sx={{ fontSize: 18 }} />,
                color: 'information' as const,
                tooltip: 'This issue is not important and can be ignored.',
            };
        default:
            return null;
    }
};

const SegregateChip: React.FC<ISegregateChipProps> = ({ type }) => {
    const props = getChipProps(type);

    if (!props) return null;

    return (

        <Chip
            variant="outlined"
            size="small"
            icon={props.icon}
            label={props.label}
            //@ts-ignore
            color={props.color}
            sx={{
                fontWeight: 600,
                // fontSize: '0.75rem',
                px: 0.5,
                borderRadius: '12px',
                border: "0px"
            }}
        />

    );
};

export default SegregateChip;
